export default __webpack_public_path__ + "static/media/carousel-mobile-1.0c7aa952.jpg";